module.exports = __webpack_public_path__ + "static/401k-icon-ad8050ede0fcc4ec52fc4f3bfd29515e.svg";